// @ts-nocheck

import React, { memo, useCallback, useContext } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import LabelTextItem from "../../LabelTextItem";
import { FormContext, useFormField, useWatch } from "../../Form";
import { ToggleProps } from "./Toggle.props";

import styles from "./Toggle.module.scss";
import globalFormStyles from "../global.formElements.module.scss";

const Toggle: React.FC<ToggleProps> = (props: ToggleProps) => {
  const {
    id,
    toggleLabel, // text to the right
    isDisabled = false, // t/f
    toggleSize = "large", // "large" | "small"
    tabIndex,
    onChange,
    name,
    containerClassName,
    displayReadOnlyFieldInline,
    readOnly,
    isLoading,
  } = props;

  const { formState, register, control, readOnly: readOnlyForm } = useContext(FormContext);
  const { isFormLoading } = formState;

  const getDisplayText
    = props.getDisplayText
    || ((toggleValue) => {
      return toggleValue && new Array(toggleValue).filter(Boolean).join("\r\n");
    });

  const checked = useWatch({
    control,
    name,
  });

  const registerField = register(name);
  const toggleContainerClass = cn("toggle-wrapper", globalFormStyles["form-field-container"], containerClassName);

  const fieldValue = useFormField(name);

  let toggleClasses = "";
  if (checked) toggleClasses = styles["on"];
  if (!checked) toggleClasses = styles["off"];
  if (isDisabled) toggleClasses = styles["disabled"];

  const handleToggleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      if (!isDisabled) {
        onChange && onChange(e);
        registerField.onChange(e);
      }
    },
    [isDisabled, onChange, registerField],
  );

  let component = null;

  if (readOnly || readOnlyForm) {
    // @ts-ignore
    const toggleValue = getDisplayText(fieldValue);
    component = (
      <LabelTextItem
        id={id}
        label={`${toggleLabel}: `}
        displayInline={displayReadOnlyFieldInline}
        body={toggleValue}
        isLoading={isFormLoading || isLoading}
        className="toggle-readonly"
      />
    );
  } else if (isLoading || isFormLoading) {
    component = <Skeleton height={20} />;
  } else {
    component = (
      <div className={styles["toggle-outer"]}>
        <div className={styles["toggle-container"]}>
          <div className={styles[toggleSize]}>
            <input
              {...registerField}
              tabIndex={tabIndex}
              aria-label={toggleLabel}
              type="checkbox"
              id={id ? `toggle_${name}_${id}` : undefined}
              data-testid={`test__${id}`}
              checked={!!checked}
              onChange={(e): void => handleToggleChange(e)}
            />
            <div className={cn(toggleClasses, styles["slider"], styles["round"], styles[toggleSize])}></div>
          </div>
          <div className={cn(styles["toggle-text"], styles[`${toggleSize}-label`])}>
            <label
              aria-label={toggleLabel}
              htmlFor={`toggle_${name}_${id}`}
              data-testid={`test__${id}-label`}
              className={styles[`${toggleSize}-label`]}
            >
              {toggleLabel}
            </label>
          </div>
        </div>
      </div>
    );
  }

  return <div className={toggleContainerClass}>{component}</div>;
};

export default memo(Toggle);
